var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNav3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.5996 6.27734C10.5996 3.69411 8.58488 1.59961 6.09961 1.59961C3.61434 1.59961 1.59961 3.69411 1.59961 6.27734L1.60547 6.51758C1.69916 8.43969 2.90932 10.0553 4.5752 10.6787C4.28223 11.0481 3.96125 11.3287 3.68457 11.5312C3.30234 11.8111 3.06542 12.2932 3.18359 12.752C3.30718 13.2316 3.77516 13.5326 4.25195 13.3984C6.09677 12.8787 10.3245 11.2033 10.5869 6.71973L10.5996 6.27734ZM12.1992 6.27734C12.1991 9.2581 10.7952 11.3283 9.15723 12.6777C7.56497 13.9895 5.73826 14.6421 4.68652 14.9385C3.25658 15.3414 1.95868 14.4079 1.63477 13.1514C1.41993 12.3175 1.6425 11.5494 2.04297 10.9639C0.782854 9.80459 9.77513e-05 8.1204 0 6.27734C0 2.86932 2.67294 1.52137e-06 6.09961 0C9.52628 0 12.1992 2.86932 12.1992 6.27734Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNav3);
export default __webpack_public_path__ + "static/media/nav_3.d54c463efeb1c2e9a0546ad16ef0047d.svg";
export { ForwardRef as ReactComponent };